module.exports = __webpack_public_path__ + "static/media/boxes.c5e5fe3a.jpg";